var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-teacher-report"},[_c('report-header',{attrs:{"basicInfo":_vm.datas,"textName":""},on:{"changeClassByData":_vm.changeClassByData}}),_c('practice-content',{attrs:{"type":_vm.scienceArr.includes(Number(_vm.datas.subject_id)),"overviewData":_vm.datas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }